import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Delete(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </SvgIcon>
  )
}
